import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import messages from 'assets/images/icons/messages.svg';
import integration from 'assets/images/icons/integration.svg';
import mask from 'assets/images/icons/mask.svg';
import InfoCard from 'partial/components/InfoCard';
import HistogramCard, {
  useHistogramCard,
} from 'partial/components/HistogramCard';
import { useShowSubscriber } from 'modules/for-verification/hooks';
import {
  useMessagesHistogram,
  useTotalInteg,
  useTotalMasks,
  useTotalMsgs,
} from '../hooks';

const loader = <div className="bg-gray-50 animate-pulse h-[120px]" />;

const msgHistogramOptions = [
  {
    id: 'messages',
    label: 'TOTAL MESSAGES',
    hook: useMessagesHistogram,
    defaultChart: 'line',
    defaultMode: 'month',
  },
];

function Icon({ type }) {
  const which = {
    mask,
    messages,
    integration,
  };
  return <img src={which[type]} alt={type} className="w-[70px]" />;
}

Icon.propTypes = {
  type: PropTypes.string.isRequired,
};

function Dashboard() {
  const { id } = useParams();
  const [, subscriber] = useShowSubscriber(id);
  const [isMsgLoading, msgData] = useTotalMsgs(subscriber?.organization?.uuid);
  const [isIntegLoading, integData] = useTotalInteg(
    subscriber?.organization?.uuid,
  );
  const [isMaskLoading, masksData] = useTotalMasks(
    subscriber?.organization?.uuid,
  );

  const messagesHistogram = useHistogramCard(msgHistogramOptions);

  return (
    <div className="h-full flex flex-col px-4 space-y-4 overflow-hidden">
      <div className="grid grid-cols-1 gap-2 lg:grid-cols-3 lg:gap-4">
        <InfoCard
          label="TOTAL MESSAGES"
          total={msgData?.total_messages || '0'}
          icon={<Icon type="messages" />}
          isLoading={isMsgLoading}
          loader={loader}
          image
        />
        <InfoCard
          label="TOTAL INTEGRATION"
          total={integData?.total_api_keys || '0'}
          icon={<Icon type="integration" />}
          isLoading={isIntegLoading}
          loader={loader}
          image
        />
        <InfoCard
          label="MASK NAMES"
          total={masksData?.total_messages || '0'}
          icon={<Icon type="mask" />}
          isLoading={isMaskLoading}
          loader={loader}
          image
        />
      </div>
      <div className="flex-1 col-span-1 xl:col-span-2 pb-3">
        <HistogramCard
          {...messagesHistogram}
          extraParam={subscriber?.organization?.uuid}
          customHeight={400}
        />
      </div>
    </div>
  );
}

export default Dashboard;
